module.exports = __webpack_public_path__ + "static/media/r-telecom_logo.9f9d5c9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/imgs/r-telecom_logo.png
// module id = 667
// module chunks = 0